<template>
  <b-tabs class="tabs-swift__container" :class="classContainer">
    <template v-for="(tab, index) in tabs">
      <b-tab
          v-if="tab.isShow ? tab.isShow : true"
          :key="index"
          :title="tab.title"
          :active="tab.isActive"
          :class="tab.class"
          :title-item-class="customClassTitleItem"
          @click="handleChangeTab(index)"
          lazy
      >
        <template #title>
          <div
            v-if="tab.isTabTitleCustom"
            class="tabs-swift__title-custom"
          >
            <img
              :class="['tabs-swift__title-img', `icon-${tab.title.toLowerCase()}`]"
              :src="require(`@/assets/images/account/${tab.srcIconTab}`)"
            />
            <div class="tabs-swift__title-text">{{ tab.title }}</div>
            <img v-if="tab.isActive ? tab.isActive : false"
              class="tabs-swift__title-icon-up"
              src="@/assets/images/account/toggle-open.png"
            />
          </div>
          <label
            v-else-if="tab.numberTabTitleNotify"
            class="tabs-swift__title-notify"
          >
            <span class="tabs-swift__title-text">{{ tab.title }}</span>
          </label>
        </template>
        <component :is="tab.component" :data="tab.data" :isPosDevice="isPosDevice"/>
      </b-tab>
    </template>
  </b-tabs>
</template>

<script>
  import lottoService from '@/services/lotto.service';
export default {
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    isPosDevice: {
      type: Boolean,
      default: false
    },
    customClassTitleItem: {
      type: String,
      default: ''
    },
    classContainer: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleChangeTab(index) {
      this.$store.state.tickets = [];
      this.$store.state.ticketsLength = 0;

      this.lotoNumbers = lottoService.generateTickets(8);

      this.tabs.forEach((item, i) => {
        item.isActive = index === i;
      })
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/common/tab/_tab-swift.scss"/>
